import {IElementBase} from '../../../../incase-domain/elements/base/elementBase';
import {ELEMENT} from '../../../../incase-domain/elements/base/ElementTypes';
import {FONT_SIZE, Font, FontSize, IPresentationTheme} from '../../../../incase-domain/presentationTheme';
import {defaultFonts} from '../../../../utils/defaultFonts';

type ElementStyles = NonNullable<IPresentationTheme['elementStyles']>;

export function getSelectedThemeFont(presentationTheme: IPresentationTheme): Font {
    return (
        [...(presentationTheme.fonts || []), ...(presentationTheme.defaultFonts || defaultFonts)].find((font) => font.selected) ||
        defaultFonts[0]
    );
}

export function toThemeFontSize(value: number, fontSizes: FontSize[]): FontSize;
export function toThemeFontSize(value: FontSize | undefined, fontSizes: FontSize[]): FontSize | undefined;
export function toThemeFontSize(value: number | FontSize | undefined, fontSizes: FontSize[]): FontSize | undefined {
    if (value === undefined) return undefined;
    const numeric = typeof value === 'number' ? value : value.value;
    const matched = fontSizes.find((size) => Math.abs(size.value - numeric) < 0.001);
    return matched || {size: FONT_SIZE.MEDIUM, value: numeric};
}

export function patchThemeStyles(theme: IPresentationTheme, keys: (keyof ElementStyles)[], patch: object): IPresentationTheme {
    const elementStyles: ElementStyles = {...theme.elementStyles};
    keys.forEach((key) => {
        const current = (elementStyles[key] ?? {}) as object;
        (elementStyles as Record<string, object>)[key] = {...current, ...patch};
    });
    return {...theme, elementStyles};
}

export function themeElementFrame(id: string, type: ELEMENT, font: Font): IElementBase {
    return {
        id,
        name: `theme-${type}-preview`,
        type,
        xPosition: 0,
        yPosition: 0,
        angle: 0,
        height: 'auto',
        width: '100%',
        slideId: 'theme-preview',
        keyIndex: id,
        elementIndex: 0,
        title: '',
        label: '',
        color: '',
        fontFamily: font,
    };
}
